export { default } from './BadgeNovelty';
